import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import './StationBreakdown.css'

ChartJS.register(ArcElement, Tooltip, Legend)

const StationBreakdown: React.FC = () => {
  const data = {
    datasets: [
      {
        data: [621, 189, 115, 122],
        backgroundColor: ['#3378F3', '#9cd9a9', '#3da8f0', '#ffea00'],
        borderWidth: 0,
      },
    ],
    labels: ['Lagos', 'Abuja', 'Port Harcourt', 'Others'],
  }

  const options = {
    cutout: '70%',
    plugins: {
      legend: {
        display: false,
      },
    },
  }

  return (
    <div className='station-breakdown'>
      <div className='station-breakdown-header'>
        <p className="station-breakdown-title">
          Station breakdown by locations
        </p>
      </div>
      <div className='station-breakdown-body'> 
            <div className='station-breakdown-chart-container'>
              <div className='station-breakdown-chart-wrapper'>
                <div className='station-breakdown-chart'>
                  <Doughnut data={data} options={options} />
                  <div className='station-breakdown-chart-center'>
                    <div className='station-breakdown-chart-center-content'>
                      <p className="station-breakdown-chart-label">
                        Total Stations
                      </p>
                      <p className="station-breakdown-chart-value">
                        950
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            <div className='station-breakdown-legend'>
              <div className='station-breakdown-legend-item'>
                <div className='station-breakdown-legend-label'>
                  <div className='station-breakdown-legend-color station-breakdown-legend-color--lagos'></div>
                  <p className="station-breakdown-legend-text">
                    Lagos
                  </p>
                </div>
                <p className="station-breakdown-legend-value">
                  621 (59%)
                </p>
              </div>
              <div className='station-breakdown-legend-item'>
                <div className='station-breakdown-legend-label'>
                  <div className='station-breakdown-legend-color station-breakdown-legend-color--abuja'></div>
                  <p className="station-breakdown-legend-text">
                    Abuja
                  </p>
                </div>
                <p className="station-breakdown-legend-value">
                  189 (18%)
                </p>
              </div>
              <div className='station-breakdown-legend-item'>
                <div className='station-breakdown-legend-label'>
                  <div className='station-breakdown-legend-color station-breakdown-legend-color--port-harcourt'></div>
                  <p className="station-breakdown-legend-text">
                    Port Harcourt
                  </p>
                </div>
                <p className="station-breakdown-legend-value">
                  115 (11%)
                </p>
              </div>
              <div className='station-breakdown-legend-item'>
                <div className='station-breakdown-legend-label'>
                  <div className='station-breakdown-legend-color station-breakdown-legend-color--others'></div>
                  <p className="station-breakdown-legend-text">
                    Others
                  </p>
                </div>
                <p className="station-breakdown-legend-value">
                  122 (12%)
                </p>
              </div>
            </div>
          </div>
        </div> 
    
  )
}

export default StationBreakdown
